import Modal from "react-bootstrap/Modal";
import LogsScreen from "../Scrapper/Logs/LogsScreen";

function SyncLogsModal({ show, setShow, logs }) {

  return (
    <>
      <Modal show={show} fullscreen={true} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Sync Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mx-4" style={{ marginTop: "50px" }}>
            {!logs && <h3>No logs found</h3>}
            <>
              <LogsScreen logs={logs} height="880px" from="sync" />
            </>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SyncLogsModal;
